export class DropZoneDataTransfer {
    public stringContent: string[];
    public fileContent: File[];

    constructor(stringContent: string[], fileContent: File[]) {
        this.stringContent = stringContent;
        this.fileContent = fileContent;
    }
}
